import { articleApiClient } from '@api/clients';
import { useQuery, UseQueryResult } from 'react-query';

export const fetchWriterArticlesCount = async (
  authorID: string,
): Promise<number> => {
  const { data } = await articleApiClient.articlesCountGet(
    {},
    {
      params: { 'author.id': authorID },
    },
  );

  return data;
};

export const useWriterArticlesCount = (
  authorID: string,
): UseQueryResult<number> => {
  return useQuery(['writer-articles-count', authorID], () =>
    fetchWriterArticlesCount(authorID),
  );
};
